export const diagnosticRegions = {
  right: [{ type: 'accessibility_button' }, { type: 'flagitem_button' }, { type: 'notepad_button' }],
  items: [
    {
      type: 'slider_element',
    },
  ],
  /*'bottom-right': [
    { type: 'next_button' },
    {
      type: 'submit_button', // Learnosity automatically shows this ONLY on the last item
    },
  ],*/
};
